// Copied from ds/src/utils/isRouteActive.ts
import { matchPath } from 'react-router';

export function isRouteActive(path: string | undefined, pathname: string): boolean {
  return path ? !!matchPath({ path, end: false }, pathname) : false;
}
